module.exports = __webpack_public_path__ + "img/nelia.e4130466.png";